import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const TRANSITION_AND_RANK_MUTATION = gqlTagGira`
    mutation TransitionAndRankJWMBoardView ($input: JWMTransitionAndRankItemInput!) {
        transitionAndRankJwmItems(input:$input, fieldIdsToReturn:["issueId"]) {  
            success,
            errors {
              message
              extensions {
                statusCode
              }
            }
        }
    }
`;
